module.exports = __webpack_public_path__ + "img/noticeimg.1017415a.png";